$(document).ready(function(){


	//resize logo on scroll
	$(window).scroll(function () {
		if ($(document).scrollTop() < 50) {
		  $('.freshwater-menu-logo.logo img').removeClass('freshwater-menu-logo-img-smaller');	
		  $('.freshwater-menu-links-left').removeClass('freshwater-menu-links-left-alt');	
		  $('.freshwater-menu-links-right').removeClass('freshwater-menu-links-right-alt');	
		  
		} else {
		  $('.freshwater-menu-logo.logo img').addClass('freshwater-menu-logo-img-smaller');		  
		  $('.freshwater-menu-links-left').addClass('freshwater-menu-links-left-alt');	
		  $('.freshwater-menu-links-right').addClass('freshwater-menu-links-right-alt');	
		}
	});

	//homepage wholesale wraper
	$("button.index-wholesale-button").click(function() {
		$(".choose-wholesale").hide();
		// $(".header").addClass("z-index-1000");
	});
	//magnifying glass
	$(".show-four img").click(function() {
		$(".magnify-row img").removeClass();
		$(this).addClass("magnify-row-img-bkg");
		$(".thumbnail").removeClass().addClass("thumbnail three-per-row");
	});
	$(".show-five img").click(function() {
		$(".magnify-row img").removeClass();
		$(this).addClass("magnify-row-img-bkg");
		$(".thumbnail").removeClass().addClass("thumbnail four-per-row");
	});
	$(".show-six img").click(function() {
		$(".magnify-row img").removeClass();
		$(this).addClass("magnify-row-img-bkg");
		$(".thumbnail").removeClass().addClass("thumbnail five-per-row");
	});	


	//contact button
	$("#trigger-contact-popup button").click(function () {
		$("#freshwater-contact-popup").show();
		$("#content_wrapper").addClass('background-darker');
	});
	$("#freshwater-contact-popup span.close-popup").click(function () {
		$("#freshwater-contact-popup").hide();
		$("#content_wrapper").removeClass('background-darker');
	});

});

